/**
 * totalCosts and salePrice2 are stored in the quote currency.
 * salePrice is stored in COP.
 * exchange is how many COP one unit of the foreign currency is worth.
 */
export function amountInProjectCurrency(
    amount,
    quoteCurrency,
    projectCurrency,
    exchange
) {
    const value = Number(amount || 0)
    if (!Number.isFinite(value)) return 0
    const from = String(quoteCurrency || '').toUpperCase()
    const to = String(projectCurrency || '').toUpperCase()
    if (!from || !to || from === to) return value
    const rate = Number(exchange)
    if (!Number.isFinite(rate) || rate <= 0) return value
    if (from === 'USD' && to === 'COP') return value * rate
    if (from === 'COP' && to === 'USD') return value / rate
    return value
}

export function quoteTotalInProjectCurrency(quote, projectCurrency) {
    return amountInProjectCurrency(
        quote?.totalCosts,
        quote?.currency,
        projectCurrency,
        quote?.exchange
    )
}

export function costTotalInProjectCurrency(cost, quote, projectCurrency) {
    const from = String(quote?.currency || '').toUpperCase()
    const to = String(projectCurrency || '').toUpperCase()
    if (from === 'USD' && to === 'COP') {
        const sale = Number(cost?.salePrice)
        if (Number.isFinite(sale) && sale !== 0) return sale
    }
    return amountInProjectCurrency(
        cost?.salePrice2,
        quote?.currency,
        projectCurrency,
        quote?.exchange
    )
}
